import { Badge, Box } from "@mui/material";
import { CustomIconButton } from "@/components/common/customIconButton";
import { useOptionalDataCompleteness } from "@/context/DataCompletenessContext";

export const DATA_GREEN = "#1B7A63";
export const DATA_RED = "#C62828";

/** A red or green dot, as used in the toolbar and the Users page. */
export function DataStatusDot({
  red,
  size = 12,
}: {
  red: boolean;
  size?: number;
}) {
  return (
    <Box
      component="span"
      data-testid={red ? "data-status-red" : "data-status-green"}
      sx={{
        width: size,
        height: size,
        borderRadius: "50%",
        display: "inline-block",
        flexShrink: 0,
        backgroundColor: red ? DATA_RED : DATA_GREEN,
      }}
    />
  );
}

/** Toolbar traffic light for the data the current user is responsible for. */
export function DataCompletenessButton() {
  const completeness = useOptionalDataCompleteness();
  if (!completeness?.data) return null;
  const { outstanding, openDialog } = completeness;

  const red = outstanding > 0;
  return (
    <CustomIconButton
      tooltip={
        red
          ? `${outstanding} ${outstanding === 1 ? "item needs" : "items need"} your input`
          : "Your deal data is up to date"
      }
      onClick={openDialog}
      icon={
        <Badge
          badgeContent={outstanding}
          color="error"
          max={99}
          invisible={!red}
          sx={{ "& .MuiBadge-badge": { top: 2, right: 2 } }}
        >
          <Box
            sx={{
              width: 20,
              height: 20,
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <DataStatusDot red={red} size={14} />
          </Box>
        </Badge>
      }
    />
  );
}
